import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { PersistOptions } from "zustand/middleware";
import type { CompanySettings, NodeTableColumnSettings } from "~/utils/apiUtil";

export interface SettingState {
  companySettings: CompanySettings | null;

  setCompanySettings: (companySettings: CompanySettings) => void;

  // Computed values
  getNodeTableColumns: () => NodeTableColumnSettings[];

  reset: () => void;
}

const useSettingState = create<SettingState>()(
  persist(
    (set, get) => ({
      companySettings: null,

      setCompanySettings: (settings: object) =>
        set(() => ({ companySettings: settings })),

      getNodeTableColumns: () => {
        const ntcStr = get().companySettings?.NODE_TABLE_COLUMNS;
        if (!ntcStr) return defaultNodeTableColumns;

        try {
          let res = JSON.parse(ntcStr) as NodeTableColumnSettings[];
          if (res.length <= 0) return defaultNodeTableColumns;

          return res;
        } catch {
          return defaultNodeTableColumns;
        }
      },

      reset: () =>
        set(() => ({
          companySettings: null,
        })),
    }),
    {
      name: "setting-state",
    } as PersistOptions<SettingState>,
  ),
);

export const defaultNodeTableColumns: NodeTableColumnSettings[] = [
  {
    index: 0,
    title: "Node Type",
    key: "nodeType",
    subgroup: "Default",
    isDefault: true,
    isAttribute: false,
    useLangLine: true,
    langLine: "tag.fields.nodeType",
    sortable: null,
  },
  {
    index: 1,
    title: "Name",
    key: "name",
    subgroup: "Default",
    isDefault: true,
    isAttribute: false,
    useLangLine: true,
    langLine: "tag.fields.name",
    sortable: null,
  },
  {
    index: 2,
    title: "DevEUI",
    key: "deveui",
    subgroup: "Default",
    isDefault: true,
    isAttribute: false,
    useLangLine: true,
    langLine: "tag.fields.deveui",
    sortable: null,
  },
  {
    index: 2,
    title: "Application",
    key: "application",
    subgroup: "Default",
    isDefault: true,
    isAttribute: false,
    useLangLine: true,
    langLine: "tag.fields.application",
    sortable: null,
  },
  {
    index: 3,
    title: "Type",
    key: "decoder",
    subgroup: "Default",
    isDefault: true,
    isAttribute: false,
    useLangLine: true,
    langLine: "tag.fields.type",
    sortable: null,
  },
  {
    index: 4,
    title: "RSSI",
    key: "rssi",
    subgroup: "Default",
    isDefault: true,
    isAttribute: false,
    useLangLine: false,
    langLine: null,
    sortable: null,
  },
  {
    index: 5,
    title: "Last Contact",
    key: "lastContact",
    subgroup: "Default",
    isDefault: true,
    isAttribute: false,
    useLangLine: true,
    langLine: "tag.fields.latestValue",
    sortable: null,
  },
  {
    index: 6,
    title: "Aktiv",
    key: "active",
    subgroup: "Default",
    isDefault: true,
    isAttribute: false,
    useLangLine: true,
    langLine: "tag.fields.activeData",
    sortable: false,
  },
];

export default useSettingState;
